export const mockCourseDays = [
  { id: 1, value: "1", name: "Sunday", arabic_name: "الأحد" },
  { id: 2, value: "2", name: "Monday", arabic_name: "الاثنين" },
  { id: 3, value: "3", name: "Tuesday", arabic_name: "الثلاثاء" },
  { id: 4, value: "4", name: "Wednesday", arabic_name: "الأربعاء" },
  { id: 5, value: "5", name: "Thursday", arabic_name: "الخميس" },
  { id: 6, value: "6", name: "Friday", arabic_name: "الجمعة" },
  { id: 7, value: "7", name: "Saturday", arabic_name: "السبت" },
];

export const mockCourseData = {
  title: "",
  course_category_id: 0,
  start_date: "",
  end_date: "",
  count_days: 0,
  last_registration_date: "",
  course_day_id: [],
  course_level: "BEGINNER",
  course_type: "ONLINE",
  course_period: "MORNING",
  country_id: 19,
  city_id: 0,
  address: "",
  status: false,
  course_lang: "AR",
  certificate: "YES",
  tutor_name: "",
  tutor_profile: "",
  image: null,
  benefit: "",
  target_group: "",
  discount: false,
  price: 0,
  course_principle: "",
  max_std_num: 0,
  brochure: null,
  email: "",
  show_email: false,
  mobile: "",
  show_mobile: false,
  phone: "",
  show_phone: false,
  description: "",
  logo: null,
  company_id: 0,
};

export const mockCertificates = [
  { id: 1, name: "Yes", value: "YES", arabic_name: "نعم" },
  { id: 2, name: "No", value: "NO", arabic_name: "لا" },
  {
    id: 3,
    name: "Certificate of Presence",
    value: "CERTIFICATE_OF_PRESENCE",
    arabic_name: "شهادة حضور",
  },
];

export const mockCourseLanguages = [
  { id: 1, name: "Arabic", value: "AR", arabic_name: "العربية" },
  { id: 2, name: "English", value: "EN", arabic_name: "الإنجليزية" },
];

export const mockCourseTimings = [
  { id: 1, name: "Morning", value: "MORNING", arabic_name: "صباحي" },
  { id: 2, name: "Evening", value: "EVENING", arabic_name: "مسائي" },
  {
    id: 3,
    name: "Not Specified",
    value: "NOT_SPECIFIED",
    arabic_name: "غير محدد",
  },
];

export const mockCourseTypes = [
  { id: 1, name: "Online", value: "ONLINE", arabic_name: "عن بعد" },
  { id: 2, name: "Onsite", value: "ONSITE", arabic_name: "حضوري" },
  { id: 3, name: "Both", value: "BOTH", arabic_name: "كلاهما" },
];
export const mockCourseLevels = [
  { id: 1, name: "Beginner", value: "BEGINNER", arabic_name: "مبتدئ" },
  {
    id: 2,
    name: "Intermediate",
    value: "INTERMEDIATE",
    arabic_name: "متوسط",
  },
  { id: 3, name: "Advanced", value: "ADVANCED", arabic_name: "متقدم" },
  { id: 4, name: "Expert", value: "EXPERT", arabic_name: "خبير" },
];

export const mockCategories = [
  {
    id: 8,
    name: "Desired Work Location",
    name_trans: { ar: "المكان المفضل للعمل" },
  },
  { id: 9, name: "Programming", name_trans: { ar: "برمجة" } },
];

export const mockEducationalInstitutions = [
  {
    id: 3,
    name: "Homs University",
    arabic_name: "جامعة حمص",
    order: 6,
    status: true,
    created_at: "2025-02-02",
    updated_at: "2025-05-03",
  },
  {
    id: 4,
    name: "Damascus University",
    arabic_name: "جامعة دمشق",
    order: 1,
    status: true,
    created_at: "2025-01-01",
    updated_at: "2025-05-03",
  },
];
